import React from "react";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction";
import Money from "@material-ui/icons/Money";
import Interesting from "@material-ui/icons/Visibility";

function BottomNav({ active }) {
  const useStyles = makeStyles((theme) => ({
    stickToBottom: {
      width: "100%",
      position: "fixed",
      bottom: 0,
    },
  }));
  const classes = useStyles();
  const [value, setValue] = React.useState(1);

  return (
    <BottomNavigation
      value={active}
      onChange={(event, newValue) => {
        setValue(newValue);
      }}
      showLabels
      className={classes.stickToBottom}
      style={{ backgroundColor: "#e6e6e6" }}
    >
      <BottomNavigationAction
        label="Calculate"
        icon={<Money />}
        component={Link}
        to="/home"
      />
      <BottomNavigationAction
        label="Interesting"
        icon={<Interesting />}
        component={Link}
        to="/interesting"
      />
    </BottomNavigation>
  );
}

export default BottomNav;
